import type { Question } from '@/api';
import { OPT, OPT_BAR, OPT_MARK, OPT_TEXT, optionVerdict } from '@/components/option';

interface QuestionOptionsProps {
  answers: Question['answers'];
  answered: boolean;
  selected: number | null;
  onChoose: (answerIndex: number) => void;
  label: string;
}

export function QuestionOptions({
  answers,
  answered,
  selected,
  onChoose,
  label,
}: QuestionOptionsProps) {
  return (
    <div className="flex flex-col gap-2.5" role="radiogroup" aria-label={label}>
      {answers.map((a) => (
        <button
          key={a.answer_index}
          type="button"
          role="radio"
          aria-checked={selected === a.answer_index}
          data-opt
          className={OPT}
          data-verdict={optionVerdict(answered, a.is_correct, selected === a.answer_index)}
          disabled={answered}
          onClick={() => onChoose(a.answer_index)}
        >
          <span className={OPT_BAR} aria-hidden />
          <span className={OPT_TEXT}>{a.answer_text ?? '—'}</span>
          <span className={OPT_MARK} aria-hidden>
            {answered && a.is_correct ? '✓' : answered && selected === a.answer_index ? '✕' : ''}
          </span>
        </button>
      ))}
    </div>
  );
}
